// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  ose: false,
  kaligo: false,
  mathiaC3: true,
  locale: 'fr-FR',
  lmsUrl: "",
  // Version du contenu Mathia : sélectionne le jeu de gabarits, d'exercices et de
  // parcours renvoyé par WordPress et par l'API adaptative. Les numérotations de
  // `app_mathia_get_gabarits3` et du champ `gabarit` des exercices ne concordent
  // que si tous les appels demandent la même version.
  contentVersion: 20,
  // Token de dev injecté quand aucun accesstoken n'est passé en URL (vide = page de login).
  debugToken: "",
  // API de l'assistant enseignant (serveur_llm, FastAPI), appelée par la page assistant-enseignant.
  // Le serveur de dev tourne sur le port 8000 (`fastapi dev main.py`).
  assistantUrl: "https://api.sublms.mathia.education/",
  // Clé API du serveur de l'assistant (en-tête X-API-Key, = API_KEY de son .env).
  // Elle finit dans le bundle : ce n'est pas un secret, c'est l'accesstoken qui authentifie.
  assistantApiKey: "AiBxHmn6VFjazvEJ5p5eUqBKUXw7d87qM9AJr9u9_ZY"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
